import type { ClientEnvironment } from '@polyai/common/constants/global.constants';

import ENDPOINTS from 'api/endpoints';
import { doDelete, doGet, doPost, doPut } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import { generateNextPath } from 'lib/routeHelper';
import type { IntegrationRecord } from './types';

export const createIntegrationRecord = ({
  accountId,
  projectId,
  integration,
  clientEnv,
  versionHash,
  data,
}: {
  accountId: string;
  projectId: string;
  integration: string;
  clientEnv: ClientEnvironment;
  versionHash: string;
  data: Record<string, any>;
}) => {
  const body = {
    integration,
    client_env: clientEnv,
    version_hash: versionHash,
    data,
  };

  return doPost(
    generateNextPath(ENDPOINTS.INTEGRATION_RECORDS, {
      accountId,
      projectId,
    }),
    LOGGER_TYPE.JUPITER,
    body,
    {
      version: 'v2',
    },
  );
};

export const updateIntegrationRecord = ({
  accountId,
  projectId,
  integration,
  integrationRecordId,
  clientEnv,
  versionHash,
  data,
}: {
  accountId: string;
  projectId: string;
  integration: string;
  integrationRecordId: string;
  clientEnv: ClientEnvironment;
  versionHash: string;
  data: Record<string, any>;
}) => {
  const body = {
    integration,
    client_env: clientEnv,
    version_hash: versionHash,
    data,
  };

  return doPut(
    generateNextPath(ENDPOINTS.INTEGRATION_RECORD, {
      accountId,
      projectId,
      integrationRecordId,
    }),
    LOGGER_TYPE.JUPITER,
    body,
    {
      version: 'v2',
    },
  );
};

export const getIntegrationRecords = ({
  accountId,
  projectId,
}: {
  accountId: string;
  projectId: string;
}) => {
  return doGet<IntegrationRecord[]>(
    generateNextPath(ENDPOINTS.INTEGRATION_RECORDS, { accountId, projectId }),
    LOGGER_TYPE.JUPITER,
    {
      version: 'v2',
      disableRetry: true,
    },
  );
};

export const deleteIntegrationRecord = ({
  accountId,
  projectId,
  integrationRecordId,
}: {
  accountId: string;
  projectId: string;
  integrationRecordId: string;
}) => {
  return doDelete(
    generateNextPath(ENDPOINTS.INTEGRATION_RECORD, {
      accountId,
      projectId,
      integrationRecordId,
    }),
    LOGGER_TYPE.JUPITER,
    {},
    {
      version: 'v2',
    },
  );
};
